import { View } from "react-native";
import { Divider, List, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { DeliveryMode } from "../../types";

type Props = {
  modes: Record<DeliveryMode, { enabled: boolean; onPress: () => void }>;
};
export default function DeliveryModeList({ modes }: Props) {
  const tailwind = useTailwind();

  return (
    <View>
      <List.Subheader>Tipos de envío</List.Subheader>
      <Item
        title="Automáticos"
        description="Cuanto coordina la recolección y entrega de tus pedidos en todo Panamá."
        icon="truck-fast-outline"
        enabled={modes.automatic.enabled}
        onPress={modes.automatic.onPress}
      />
      <Divider style={tailwind("mx-4")} />
      <Item
        title="Manuales"
        description="Crea y configura tus propias tarifas y zonas de entrega."
        icon="moped"
        enabled={modes.manual.enabled}
        onPress={modes.manual.onPress}
      />
    </View>
  );
}

type ItemProps = {
  title: string;
  icon: string;
  description: string;
  enabled: boolean;
  onPress?: () => void;
};
function Item({ title, icon, description, enabled, onPress }: ItemProps) {
  const tailwind = useTailwind();

  return (
    <List.Item
      title={title}
      left={({ color }) => {
        return (
          <List.Icon
            icon={icon}
            style={tailwind("self-center ml-4")}
            color={color}
          />
        );
      }}
      description={description}
      descriptionNumberOfLines={0}
      right={() => <StatusText enabled={enabled} />}
      onPress={onPress}
    />
  );
}

function StatusText({ enabled }: { enabled: boolean }) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  const color = enabled ? colors.secondary : colors.onSurfaceVariant;
  const text = enabled ? "Activo" : "Inactivo";
  return (
    <Text style={[tailwind("ml-4 self-center text-right"), { color }]}>
      {text}
    </Text>
  );
}
